import type { ReactNode } from 'react';

import VNFieldHelpIconButton from './VNFieldHelpIconButton';

type Props = {
  label: ReactNode;
  required?: boolean;
  helperTooltip?: string;
  showIcon?: boolean;
  clickable?: boolean;
  panelOpen?: boolean;
  onIconClick?: () => void;
  drawerAriaLabel?: string;
};

const VNFieldHelpLabel = ({
  label,
  required = false,
  helperTooltip,
  showIcon = false,
  clickable = false,
  panelOpen = false,
  onIconClick,
  drawerAriaLabel,
}: Props) => (
  <div className="vn-field-help__label">
    <span>
      {label}
      {required ? ' *' : ''}
    </span>
    {showIcon && (
      <VNFieldHelpIconButton
        active={panelOpen}
        helperTooltip={helperTooltip}
        onClick={clickable ? onIconClick : undefined}
        ariaLabel={drawerAriaLabel}
      />
    )}
  </div>
);

export default VNFieldHelpLabel;
